<template>
  <div>
    <div class="bg-white rounded  my-4 shadow-md px-4 md:px-6 py-2 overflow-hidden mt-3">
      <h2 class="text-gray-800 text-lg font-bold text-center uppercase">Naše nejstarší minulost v pověstech</h2>
      <div>
        <p class="pb-2">
          Období trvající asi let po Sámově říši, o kterém nemáme žádné písemné zprávy, lákalo k <strong>vymýšlení příběhů o činech našich předků</strong>. Vznikali tak
          <strong>historické pověsti</strong>, které se mezi lidmi šířily nejprve ústním podáním. Pověsti jsou ted <strong>vymyšlené příběhy</strong>, které ale mohou mít
          <strong>pravdivé jádro</strong>. Na základě lidového vyprávění je později zaznamenali kronikáři a někteří čeští spisovatelé.
        </p>
        <div class="lg:flex items-center pb-2">
          <img class="w-full lg:w-1/5 rounded" src="https://upload.wikimedia.org/wikipedia/commons/e/e9/Josef_Mathauser_-_Praotec_%C4%8Cech_na_ho%C5%99e_%C5%98%C3%ADp.jpg" alt="" />
          <div class="px-6  w-full lg:w-3/5 bg-yellow-100">
            <p>
              <strong>Podle</strong> dochovaných <strong>pověstí</strong> přivedl <strong>praotec Čech</strong> svůj kmen pod <strong>horu Říp</strong>. Po obhlédnutí krajiny rozhodl, že se zde
              všichni usadí. Zemi pojmenovali na jeho počest <strong>Čechy</strong>. 
             
            </p>
            <p>
              Stařešina <strong>Krok</strong> měl tři dcery - Kazi, Tetu, Libuši (zapiš si to za uši). Kněžnou se stala <strong>Libuše</strong>. Ta měla nadání předpovídat (věštit) budoucnost a
              předpověděla slávu <strong>Prahy</strong>. Některým mužům však vláda ženy nevyhovovala. Libuše si tedy zvolila za manžela <strong>Přemysla Oráče ze Stadic</strong>, který se tak stal
              podle pověsti zakladatelem <strong>rodu Přemyslovců</strong>. 
              
            </p>
          </div>
          <img
            class="w-full lg:w-1/5 rounded"
            src="https://upload.wikimedia.org/wikipedia/commons/3/3d/Josef_Mathauser_-_Kn%C4%9B%C5%BEna_Libu%C5%A1e_v%C4%9B%C5%A1t%C3%AD_sl%C3%A1vu_Prahy.jpg"
            alt=""
          />
        </div>
        <div class="lg:flex py-4 items-center">
          <div class="w-full lg:w-3/4  pr-2">
            <p class="pb-2">
              Podle pověsti naše země v dalších letech vzkvétala a za knížete Křesomysla začalo mohutné dobývání zlata a stříbra. Z rolníků se stali horníci a pole neměl kdo obdělávat. To se nelíbilo
              <strong>Horymírovi</strong>. Dostal se do sporů a pak i do boje s havíři. Kníže Křesomysl proto odsoudil Horymíra k smrti. Věrný <strong>kůň Šemík</strong> přeskočil s Horymírem hradby
              tehdejšího knížecího hradu Vyšehrad a přeplaval Vltavu, takže Horymír trestu smrti unikl. 
              
            </p>
            <p class="text-sm text-gray-800 italic pb-2">
              Tyto a jiné pověsti se nám dochovaly zásluhou kněze jménem <strong>Kosmas</strong>, který je jako první zapsal před 900 lety ve své kronice.
            </p>
           
          </div>
          <div class="w-full lg:w-1/4">
            <iframe
              class="w-full h-64 lg:h-40"
              src="https://www.youtube.com/embed/3VTa4NV-TLc"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Povesti"
};
</script>

<style lang="scss" scoped></style>
